export default "__VITE_ASSET__Cj6HHAd4__"